import Configuration from '@/agilis/util/Configuration'
import DataTableTitle from './TrackerDataTableTitle/TrackerDataTableTitle.vue'

import authorizationMixin from '@/agilis/components/DataTableV2/common/authorizationMixin'
import filterMixin from '@/agilis/components/DataTableV2/common/filterMixin'
import dumpUserActionMixin from '@/agilis/components/DataTableV2/common/dumpUserActionMixin'
import configurationMixin from '@/agilis/components/DataTableV2/common/configurationMixin'
import tableActionsMixin from '@/agilis/components/DataTableV2/common/tableActionsMixin'
import searchMixin from '@/agilis/components/DataTableV2/common/searchMixin'
import renderMixin from '@/agilis/components/DataTableV2/common/renderMixin'
import toursMixin from '@/agilis/components/Tour/mixins/toursMixin'
import deleteMixin from '@/agilis/components/DataTableV2/common/deleteMixin'
import kanbanMixin from '@/agilis/components/DataTableV2/common/kanbanMixin'
import dashboardMixin from '@/agilis/components/DataTableV2/common/dashboardMixin'
import viewMixin from '@/agilis/components/DataTableV2/common/viewMixin'
import linkToMixin from '@/agilis/components/DataTableV2/common/linkToMixin'
import exportMixin from '@/agilis/components/DataTableV2/common/exportMixin'

export default {
  name: 'TrackerDataTable',
  mixins: [
    authorizationMixin,
    dumpUserActionMixin,
    filterMixin,
    configurationMixin,
    deleteMixin,
    tableActionsMixin,
    linkToMixin,
    searchMixin,
    renderMixin,
    toursMixin,
    kanbanMixin,
    dashboardMixin,
    viewMixin,
    exportMixin
  ],

  props: {
    api: String,
    propTitle: String,
    description: String,
    viewComponentId: String,
    editComponentId: String,
    configuration: Object
  },

  components: {
    DataTableTitle
  },

  computed: {
    searchApi () {
      if (this.searchViaSqlQuery) {
        if (this.trackerTypeId) {
          return this.$axios.agilisUrlQueryTrackerType(this.applicationId, this.trackerTypeId, this.dataTableConfiguration.querySelectMode)
        } else {
          return this.$axios.agilisUrlQuery(this.applicationId, this.dataTableConfiguration.querySelectMode)
        }
      }
      return this.$axios.agilisUrlDataTableSearch(this.api) // standard flow
    }
  },

  methods: {
    handleNewChildTrackerClick (parentTrackerId) {
      const itemDTO = Configuration.datatable.getDTO(this.dataTableConfiguration)
      itemDTO.parentId = parentTrackerId
      this.createItem(itemDTO)
    }
  }
}
